import axios from "axios";
import { createContext, useEffect, useReducer } from "react";
import { io } from "socket.io-client";


export const Store = createContext();

const initialState = {
  baseUrl: process.env.REACT_APP_BACKEND_URL,

  // userInfo: localStorage.getItem("userInfo")
  //   ? JSON.parse(localStorage.getItem("userInfo"))
  //   : null,
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null,


  cart: {
    cartItems: localStorage.getItem("cartItems")
      ? JSON.parse(localStorage.getItem("cartItems"))
      : [],
  },
  orderHistory: localStorage.getItem("orderHistory")
    ? JSON.parse(localStorage.getItem("orderHistory"))
    : [],
  products: [],
  noticeContent: "",
  allRechargeRequests: [],
  users: [],
  myRecharges: [],
  myOrders: [],
  CurrUser: localStorage.getItem("CurrUser")
    ? JSON.parse(localStorage.getItem("CurrUser"))
    : null,
};

function reducer(state, action) {
  switch (action.type) {
    // ---------------- RECHARGE REDUCERS
    case "UPDATE_RECHARGEDATA": {
      return { ...state, allRechargeRequests: [action.payload, ...state.allRechargeRequests] };
    }
    case "CURRENT_USER_RECHARGE_REQUEST": {
      return { ...state, myRecharges: action.payload };
    }
    case "UPDATE_MY_RECHARGE_REQUESTS": {
      return { ...state, myRecharges: [action.payload, ...state.myRecharges] };
    }

    case "GET_RECHARGE_REQUESTS":
      return { ...state, allRechargeRequests: action.payload };

      // ----------------- CART REDUCERS
    case "CART_ADD_ITEM":
      // add to cart
      // Extract the new item to be added to the cart from the action payload
      const newItem = action.payload;

      // add the new item to the cart
      const cartItems = [...state.cart.cartItems, newItem];
      // Save the updated cart items to localStorage to maintain cart details upon page refresh
      localStorage.setItem("cartItems", JSON.stringify(cartItems)); // used to maintain cart details upon page refresh
      // Return the new state with the updated cart items
      return { ...state, cart: { ...state.cart, cartItems } };

    case "CART_REMOVE_ITEM": {
      // Filter out the item to be removed from the cart
      const cartItems = state.cart.cartItems.filter(
        (item) => item.id !== action.payload.id
      );

      // Save the updated cart items to localStorage to maintain cart details upon page refresh
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      // Return the new state with the updated cart items
      return { ...state, cart: { ...state.cart, cartItems } };
    }

    case "CART_CLEAR":
      localStorage.removeItem("cartItems");
      return { ...state, cart: { cartItems: [] } };

    //------------------ ORDERS REDUCERS
    case "ORDER_HISTORY_UPDATE": {
      // replace the existing order history with the updated order history
      return { ...state, orderHistory: action.payload };
    }
    case "MY_ORDER_HISTORY": {
      return { ...state, myOrders: action.payload };
    }
    case "UPDATE_MY_ORDER_HISTORY": {
      return { ...state, myOrders: [action.payload, ...state.myOrders] };
    }
    // adds new order to previous order history
    case "UPDATE_ORDERDATA":
      return { ...state, orderHistory: [action.payload, ...state.orderHistory] };

    // ------------------- PRODUCT REDUCERS
    case "UPDATE_PRODUCTDATA": 
    const existingProductIndex = state.products.findIndex(product => product._id === action.payload._id);
    if (existingProductIndex !== -1) {
      const updatedProduct = state.products.map(product =>
        product._id === action.payload._id ? action.payload : product
      );
      return { ...state, products: updatedProduct };
    } else {
      return { ...state, products: [...state.products, action.payload] };
    }
    // what to do if the product doesn't exist already
    // return state;

    case "FETCH_PRODUCTS_SUCCESS": {
      return { ...state, products: action.payload };
    }
    // ------------------- NOTICE REDUCERS
    case "UPDATE_NOTICECONTENT": {
      return { ...state, noticeContent: action.payload };
    }
    case "SET_MOMO_DETAILS":
      return { ...state, momoDetails: action.payload };

    case "SET_NOTICE_CONTENT":
      return { ...state, noticeContent: action.payload };

  
    // ------------------------ USER REDUCERS
    case "UPDATE_USERDATA": 
    // console.log('updating userdata')
      const existingUserIndex = state.users.findIndex(user => user._id === action.payload._id);
      if (existingUserIndex !== -1) {
        const updatedUsers = state.users.map(user =>
          user._id === action.payload._id ? action.payload : user
        );
        // what to do if the user already exists
        if (action.payload._id === state.CurrUser?._id) {
          localStorage.setItem("CurrUser", JSON.stringify(action.payload));
          localStorage.setItem("userInfo", JSON.stringify(action.payload));
          return { ...state, users: updatedUsers, CurrUser: action.payload };
        }
        return { ...state, users: updatedUsers };
      } 
      return state;
      // else{
      //   const updatedUsers = [...state.users];
      //   updatedUsers[existingUserIndex] = action.payload;
      //   return { ...state, users: updatedUsers };
      // }



      // } else {
      //   // what to do if the user doesn't exist
      // return { users: [...state.users, action.payload] };
      // }
    // }

    case "USER_RECHARGE": {
      const rechargeAmount = action.payload;
      //       const updatedBalance = state.userInfo.balance = rechargeAmount;
      // console.log('updatedBalance', updatedBalance)

      // Update the user's balance in the state
      const updatedUserInfo = {
        ...state.userInfo,
        balance: rechargeAmount,
      };
      // Save the updated user info to localStorage
      localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));

      // Return the new state with the updated user info
      return { ...state, userInfo: updatedUserInfo };
    }

    case "USER_UPDATE_BALANCE": {
      const updatedUserInfo = action.payload;
      // Save the updated user info to localStorage
      localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));

      // Return the new state with the updated user info
      return { ...state, userInfo: updatedUserInfo };
    }

    case "FETCH_USERS_SUCCESS": {
      return { ...state, users: action.payload };
    }

    case "USER_SIGNIN":
      return { ...state, userInfo: action.payload };

    case "USER_SIGNOUT":
      localStorage.removeItem("userInfo");
      localStorage.removeItem("cartItems");
     localStorage.removeItem("CurrUser");
      localStorage.removeItem("orderHistory");
      window.location.href = "/";
      return {
        ...state,
        userInfo: null,
        cart: { cartItems: [] },
        orderHistory: [],
        CurrUser: null,
      };

    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  // const { user, baseUrl } = state;
  // const userInfo = JSON.parse(localStorage.getItem('userInfo'));


  // FECTH PRODUCTS
  useEffect(() => {
    const fetchProducts = async () => {
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      try {
        const { data } = await axios.get(baseUrl + "/product");
        dispatch({ type: "FETCH_PRODUCTS_SUCCESS", payload: data });
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  // FETCH NOTICE CONTENT
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const fetchNoticeContent = async () => {
      try {
        const { data } = await axios.get(baseUrl + "/extra/momo-details");
        dispatch({ type: "SET_NOTICE_CONTENT", payload: data });
        // dispatch({ type: 'SET_MOMO_DETAILS', payload: data });
      } catch (error) {
        console.error("Error fetching notice content:", error);
      }
    };
    fetchNoticeContent();
  }, []);

  // FETCH USERS
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!userInfo) 
      {
        return;
      }
    else{
    const fetchUsers = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: "FETCH_USERS_SUCCESS", payload: data });
        const currUser = data.find((user) => user._id === userInfo._id);
        const updatedCurrUser = { ...currUser, token: userInfo?.token };
        localStorage.setItem("CurrUser", JSON.stringify(updatedCurrUser));
        dispatch({ type: "UPDATE_USERDATA", payload: updatedCurrUser });
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }
  }, []);

  // FETCH RECHARGE REQUESTS
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!userInfo) 
      return;
    else{
    const fetchRechargeRequests = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/recharge`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({
          type: "GET_RECHARGE_REQUESTS",
          payload: data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          ),
        });
        const userRequests = data.filter(
          (request) => request.user._id === userInfo._id
        );
        dispatch({
          type: "CURRENT_USER_RECHARGE_REQUEST",
          payload: userRequests,
        });
      } catch (error) {
        console.error("Error fetching recharge requests:", error);
      }
    };

    fetchRechargeRequests();
  }
  }, []);

  //  FETCH ORDERS
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!userInfo){
      return;
    } else {


    const fetchOrders = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/order/allorders`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({
          type: "ORDER_HISTORY_UPDATE",
          payload: data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
        });
        const userOrders = data.filter((request) => request.user === userInfo._id);
        dispatch({ type: "MY_ORDER_HISTORY", payload: userOrders });
      } catch (error) {
        console.log("Error fetching transactions:", error);
      }
    };
    fetchOrders();
  }
  }, []);

  // SOCKET FROM BE
  useEffect(() => {
    const socket = io(process.env.REACT_APP_BACKEND_URL);

    socket.on("userUpdated", (updatedUser) => {
          dispatch({ type: "UPDATE_USERDATA", payload: updatedUser });
    });
    socket.on("noticeUpdated", (updatedNotice) => {
      // console.log("receivedNotice-update", updatedNotice);
      dispatch({ type: "UPDATE_NOTICECONTENT", payload: updatedNotice });
      // }
    });
    socket.on("productsUpdated", (updatedProducts) => {
      // console.log("receivedProduct-update", updatedProducts);
      dispatch({ type: "UPDATE_PRODUCTDATA", payload: updatedProducts });
      // }
    });
    socket.on("ordersUpdated", (updatedOrders) => {
      if (updatedOrders.user === state.userInfo._id) {
        dispatch({ type: "UPDATE_MY_ORDER_HISTORY", payload: updatedOrders });
        dispatch({ type: "UPDATE_ORDERDATA", payload: updatedOrders });
      }
    });
    socket.on("rechargeUpdated", (updatedRecharge) => {
      dispatch({ type: "UPDATE_MY_RECHARGE_REQUESTS", payload: updatedRecharge });
        dispatch({ type: "UPDATE_RECHARGEDATA", payload: updatedRecharge });
    });
    socket.on("CurrUserUpdated", (updatedCurrUser) => {
      dispatch({ type: "UPDATE_USERDATA", payload: updatedCurrUser });
      dispatch({ type: "UPDATE_USERDATA", payload: updatedCurrUser });
    });

    return () => {
      socket.disconnect();
    };
  }, [state.userInfo]);

  // useEffect(() => {
  //   if (!state.userInfo) {
  //     const socket = io(process.env.REACT_APP_BACKEND_URL);
  //     socket.disconnect();
  //   }
  // }, [state.userInfo]);

  // CONSOLE LOG
  // useEffect(() => {
    // console.log("usersFromStore", state.users);
    // console.log("rechargeRequestsFromStore", state.allRechargeRequests);
    // console.log("myRequestsFromStore", state.myRecharges);
    // console.log("OrderHistory", state.orderHistory);
    // console.log("myOrders", state.myOrders);
    // console.log("productsFromStore", state.products);
    // console.log("noticeFromStore", state.noticeContent);
  // }, [
    // state.users,
    // state.myOrders,
    // state.allRechargeRequests,
    // state.myRecharges,
    // state.orderHistory,
    // state.products,
    // state.noticeContent
  // ]);

  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children} </Store.Provider>;
}